import Modal from "components/design-system/modal";
import SizeMappingsTable from "./size-mappings-table";
import { setSizeGuideModalOpen } from "slices/pdp-slice";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

const SizeGuideModal = ({ designerName, designerNotes = "", isOpen }) => {
  const dispatch = useDispatch();
  const sizeMappings = useSelector(state => state?.pdp?.sizeMappings || []);
  const fitNotes = useSelector(state => state?.pdp?.fitNotes || null);
  const handleRequestClose = () => {
    dispatch(setSizeGuideModalOpen(false));
  };

  return (
    <Modal
      className="hidden md:block rounded-lg h-auto w-auto min-w-[40vw]"
      isOpen={isOpen}
      onClose={handleRequestClose}
      dataTestId="size-guide-modal">
      <div className="p-6 font-semibold">
        <h2 className="text-center pb-6">{designerName} Size Guide</h2>
        <div className="pb-3">
          <div className="text-md text-darkGray uppercase">Fit Details</div>
          <div dangerouslySetInnerHTML={{ __html: designerNotes }} />
        </div>

        {!!fitNotes && (
          <div className="pt-3 pb-3">
            <div className="text-md uppercase text-darkGray pb-2">Fit Notes</div>
            <div dangerouslySetInnerHTML={{ __html: fitNotes }} />
          </div>
        )}

        {sizeMappings && sizeMappings.length > 0 && (
          <div className="border-t border-lighterGray pt-3">
            <div className="text-md text-darkGray uppercase pb-3">Product Sizing</div>
            <SizeMappingsTable sizeMappings={sizeMappings} />
          </div>
        )}
      </div>
    </Modal>
  );
};

SizeGuideModal.propTypes = {
  designerName: PropTypes.string.isRequired,
  designerNotes: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
};

export default SizeGuideModal;
